import { RouteLocationNormalized, RouteRecordName } from 'vue-router'
import layoutPermissions from '~/data/permissions/layout-permissions'

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized, from: RouteLocationNormalized) => {
  const isCustomer = to.name?.toString().startsWith('customer-') || to.path?.toString().startsWith('/customer/')

  if (isCustomer) {
    return
  }

  const guests: (RouteRecordName | null | undefined)[] = [
    'index',
    'auth-login',
    'auth-register',
    'auth-forgot-password',
    'auth-reset-password',
    'embed-search-booking'
  ]

  const publicPages: (RouteRecordName | null | undefined)[] = ['auth-callback-app', 'shared-trip', 'workspace-list']

  const { auth, userConfig } = $store()

  const accessToken = auth.accessToken
  if (guests.includes(to.name) || publicPages.includes(to.name)) {
    if (publicPages.includes(to.name)) {
      // eslint-disable-next-line no-console
      console.log('Public page')
      return
    }
    if (accessToken) {
      // eslint-disable-next-line no-console
      console.log('Workspaces page')
      return navigateTo({
        // name: 'workspace-list'
        name: 'user-search-booking'
      })
    }
  } else if (accessToken) {
    const workspaceId = auth.workspaceId
    const companyType = auth.companyType
    const workspaceType = auth.workspaceType
    const cooperatorTypes = auth.cooperatorTypes || []

    //  IMPORT_AND_EXPORT
    const isAdmin = userConfig.isAdmin
    if (isAdmin) {
      console.log('System page')
      return
    }

    if (to.name?.toString().indexOf('trucker-admin-id') === 0) {
      // có quyền company admin hoặc admin_c_p_management thì đc vào trucker-admin
      const isCompanyAdmin = userConfig.isCompanyAdmin

      if (isCompanyAdmin) {
        return
      }

      if (checkPermission(layoutPermissions.adminCP.admin_c_p_management)) {
        return
      }
    }

    if (workspaceId && companyType) {
      // eslint-disable-next-line no-console
      if (workspaceType === 'VENDOR') {
        switch (companyType) {
          case 'OWNER':
            console.log(to.name?.toString().indexOf('trucker-id') !== 0 && to.name?.toString().indexOf('trucker-admin-id') !== 0)

            if (to.name?.toString().indexOf('trucker-id') !== 0 && to.name?.toString().indexOf('trucker-admin-id') !== 0) {
              return navigateTo({
                name: 'trucker-id-dashboard',
                params: { id: workspaceId }
              })
            }
            return
          case 'PARTNER':
            if (to.name?.toString().indexOf('pp-id') !== 0 && to.name?.toString().indexOf('pc-id') !== 0) {
              if (cooperatorTypes?.includes('PARTNER')) {
                return navigateTo({
                  name: 'pp-id',
                  params: { id: workspaceId }
                })
              } else if (cooperatorTypes?.includes('CUSTOMER')) {
                return navigateTo({
                  name: 'pc-id',
                  params: { id: workspaceId }
                })
              }
            }
            if (!cooperatorTypes || !cooperatorTypes.length) {
              return navigateTo({
                // name: 'workspace-list'
                name: 'user-search-booking'
              })
            }
            if (to.name?.toString().indexOf('pp-id') === 0 && !cooperatorTypes?.includes('PARTNER')) {
              return navigateTo({
                name: 'pc-id',
                params: { id: workspaceId }
              })
            }

            if (to.name?.toString().indexOf('pc-id') === 0 && !cooperatorTypes?.includes('CUSTOMER')) {
              return navigateTo({
                name: 'pp-id',
                params: { id: workspaceId }
              })
            }

            break
          default:
            return navigateTo({
              // name: 'workspace-list'
              name: 'user-search-booking'
            })
        }
      } else if (workspaceType === 'IMPORT_AND_EXPORT') {
        switch (companyType) {
          case 'OWNER':
            if (to.name?.toString().indexOf('c-id') !== 0) {
              return navigateTo({
                name: 'c-id-dashboard',
                params: { id: workspaceId }
              })
            }
            break
          default:
            return navigateTo({
              // name: 'workspace-list'
              name: 'user-search-booking'
            })
        }
      } else {
        return navigateTo({
          // name: 'workspace-list'
          name: 'user-search-booking'
        })
      }
    }
  } else {
    const backUrl = encodeURI(to.fullPath)

    if (backUrl.includes('invite')) {
      return navigateTo({
        name: 'auth-register',
        query: { backUrl, ...(to.query || {}) }
      })
    }

    return navigateTo({
      name: 'auth-login',
      query: { backUrl, ...(to.query || {}) }
    })
  }
})
